function rechargeParam(data,isPost,userInfo,isYk){
//	let commParam;
    let app_key;
    if(userInfo){
        app_key="SMBQpaBWvVZPkpcBvDwQswDWxm";
    }else if(isYk){
        app_key="TkIPhsLPyQv2LX59LhAzmVarQi";
    }else{
        app_key="AkdhaZPwXuUCMTrmitfepEnFQs";
    }
	let commParam = {
        timestamp: Math.round(new Date().getTime() / 1000),
        version: 'v1',
        format: 'json',
        app_key: app_key,
//      callback: jsonpStr?'jsonp'+jsonpStr:'jsonp',
        nonce:new Date().getMilliseconds()+"0"+Math.floor(Math.random()*10000)
    };
//	let commParam = {
//      timestamp: Math.round(new Date().getTime() / 1000),
//      version: 'v1',
//      format: 'json',
//      app_key: userInfo?'SMBQpaBWvVZPkpcBvDwQswDWxm':'AkdhaZPwXuUCMTrmitfepEnFQs',
//      callback: jsonpStr?'jsonp'+jsonpStr:'jsonp',
//      nonce:new Date().getMilliseconds()+"0"+Math.floor(Math.random()*10000)
//  };
    let newParam = extend(commParam, data.params);

    let sortParm = objKeySort(newParam);
    let row_sign = '';
    let sign = '';
    for (let i in sortParm) {
    		if(i != "callback"){
    			 row_sign += i + '=' + sortParm[i] + '&'
    		}
    }
    if(userInfo){
    		row_sign += 'dcdAlgyn1GxxageKCqKxHYSIInCqDtkIgZaubdkpqVbDJ';
    }else if(isYk){
    		row_sign += 'bsHX2wwQc3ASYUIRAE5dl9axWw0WCoWQeeri8rBflfOwE';
    }else{
        row_sign += 'FHADKcE1xONIUxTawFbigFE1GXvzOXjSASVmfXoQcKfoJ';

    }
    
    sign = md5(row_sign);
    commParam.sign = sign;
    
   let finalParam ;
// let finalParam = extend({}, commParam, data.params);
   if(isPost){
   		finalParam = extend({}, commParam,{});
   }else{
   		finalParam = extend({}, commParam, data.params);
   }
   let urldata=''
   for(let val in finalParam){
   		urldata +=  val+"="+finalParam[val]+"&";
   }

   	finalParam = urldata.substring(0, urldata.lastIndexOf("&"));
    return finalParam;
   
}
function extend(target, options) {
    for (name in options) {
        target[name] = options[name];
        
    }
    return target;
}
function objKeySort(obj){//排序的函数
	let newkey = Object.keys(obj).sort();
    let newObj = {};
    for (let i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]];
    }
    return newObj;
}
function add0(m){return m<10?'0'+m:m }

function timeFormat(timestamp){
    console.log(timestamp);
    var time = new Date(timestamp);
    var year = time.getFullYear();
    var month = time.getMonth()+1;
    var date = time.getDate();
    var hours = time.getHours();
    var minutes = time.getMinutes();
    var seconds = time.getSeconds();

    return year+'-'+add0(month)+'-'+add0(date);
}
function getUrlParam(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    let r = window.location.search.substr(1).match(reg);  //匹配目标参数
    if (r != null) return unescape(r[2]);
    return null; //返回参数值
  }
function  getUrlRelativePath() {
    let url = document.location.toString(),
      arrUrl = url.split("//"),
      start = arrUrl[1].indexOf("/"),
      relUrl = arrUrl[1].substring(start);//stop省略，截取从start开始到结尾的所有字符
    if (relUrl.indexOf("?") !== -1) {
      relUrl = relUrl.split("?")[0];
    }
    return relUrl;
}

function checkBrowser() {
    var UA = navigator.userAgent.toLowerCase();
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
  
      if ((/Alipay/i).test(UA)) {
        return 'alipay'
      } else if ((/MicroMessenger/i).test(UA)) {
        return 'wechat'
      } else if (/(uni-app)/.test(UA) || /(ylkids_android)/.test(UA) || /(ios1.1.0)/.test(UA) || /(app_charge)/.test(UA)) {
        return 'app'
      } else {
        return 'mobile'
      }
    } else {
      return 'pc'
    }
}//查看用户环境 微信/支付宝/app

export {rechargeParam,timeFormat,getUrlParam,objKeySort,getUrlRelativePath,checkBrowser};



// WEBPACK FOOTER //
// ./src/assets/js/common.js